var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.322 0.423C9.448 0.164 9.712 0 10 0C10.289 0 10.552 0.164 10.678 0.423C11.652 2.421 13.328 5.863 13.328 5.863C13.328 5.863 17.139 6.387 19.35 6.692C19.753 6.747 20 7.088 20 7.439C20 7.629 19.928 7.822 19.769 7.975C18.159 9.513 15.387 12.166 15.387 12.166C15.387 12.166 16.064 15.933 16.456 18.118C16.539 18.58 16.181 19 15.714 19C15.592 19 15.47 18.971 15.359 18.911C13.391 17.863 10 16.06 10 16.06C10 16.06 6.609 17.863 4.641 18.911C4.53 18.971 4.407 19 4.285 19C3.82 19 3.46 18.579 3.544 18.118C3.937 15.933 4.614 12.166 4.614 12.166C4.614 12.166 1.841 9.513 0.232 7.975C0.0720001 7.822 0 7.629 0 7.44C0 7.088 0.249 6.746 0.651 6.692C2.862 6.387 6.672 5.863 6.672 5.863C6.672 5.863 8.349 2.421 9.322 0.423Z",
    fill: "#FFB300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.051b6bbf2315fe5a4de671cde3f77630.svg";
export { ForwardRef as ReactComponent };